import React, { useMemo } from "react";
import MultiFeatureCard from "../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard";
import { get } from "lodash";
import GenericChart from "../GenericChart";
import useFetchAiAnalyticsWidgetData from "../../../hooks/useFetchAiAnalyticsWidgetData";
import Highcharts from "highcharts"

const TopicBySentiment = (props) => {
    const { itemData, applied_filter_values, timeperiodLabel } = props;

    const { data, isLoading } = useFetchAiAnalyticsWidgetData({
        widgetId: get(itemData, "widgetId", ""),
        appliedFilterValues: applied_filter_values,
        "widget_config": {},
    })

    const { categories, series } = useMemo(() => {
        if (!data) return { categories: [], series: [] }
        let transFormedData = get(itemData, "dataConfig", []).map((res) => ({
            name: res.label,
            color: res?.color,
            data: data?.metric_data?.map((item) => item?.[data?.columns.indexOf(res.key)])
        }))
        return { categories: get(data, "rows", []), series: transFormedData }

    }, [data])

    const defaultConfig = useMemo(() => {
        const obj = {
            legend: {
                enabled: true,
                align: 'center',
                verticalAlign: 'bottom',
                labelFormatter: function () {
                    return `<span style="color:${this.color}; font-weight:600">
              ${this.name}
            </span>`;
                },
                useHTML: true
            }



        }
        return Highcharts.merge(get(itemData, "chartDefaultConfig", {}), obj)
    }, [itemData, categories])

    return (
        <MultiFeatureCard
            loading={isLoading}
            title={get(itemData, 'title', '')}
            subTitle={timeperiodLabel}
            isNoData={!isLoading && !get(data, "rows", []).length}
            renderContent={() => {
                return (
                    <GenericChart
                        // defaultConfig={get(itemData, 'chartDefaultConfig', {})}
                        defaultConfig={defaultConfig}
                        xAxisCategories={categories}
                        series={series}
                        tooltipValueKeysConfig={{
                            isheaderVisible: true,
                            headerLabelKey: "category",
                            bodyLabelKey: "series.name",
                            bodyValueKey: "y"
                        }
                        }
                    />
                )
            }}
        />
    )
}
export default TopicBySentiment